import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Image from 'next/image';
import {
  Headline as CircuitHeading,
  List as CircuitList,
  Body,
  Button,
} from '@sumup-oss/circuit-ui';

import { StyledComponentsParams } from 'types/components';

export const AccordionList = styled(CircuitList)`
  margin-top: 0;
`;

export const ArticleText = styled(Body)(
  ({ theme }: StyledComponentsParams) => css`
    margin-top: ${theme.spacings.giga};
  `,
);

export const EmbeddedImage = styled(Image)(
  ({ theme }: StyledComponentsParams) => css`
    max-width: 100%;
    height: auto;
    border-radius: ${theme.borderRadius.mega};

    ${theme.mq.mega} {
      border-radius: ${theme.borderRadius.mega};
    }
  `,
);

export const EmbeddedImageContainer = styled.div(
  ({ theme }: StyledComponentsParams) => css`
    margin-top: ${theme.spacings.peta};
    margin-bottom: ${theme.spacings.mega};
    display: flex;
    justify-content: center;
  `,
);

export const Heading = styled(CircuitHeading)(
  ({ theme, as }: StyledComponentsParams & { as: string }) => css`
    ${as === 'h2' &&
    `
    margin-top: ${theme.spacings.peta};
    margin-bottom: ${theme.spacings.giga};
    ${theme.mq.untilMega} {
      margin-top: calc(2*${theme.spacings.tera});
    }
    `};
    ${as === 'h3' &&
    `
    margin-top: ${theme.spacings.tera};
    margin-bottom: ${theme.spacings.giga};

    ${theme.mq.mega} {
      margin-top: ${theme.spacings.zetta};
    }
  `}
    & span {
      font-size: inherit;
    }
  `,
);

export const List = styled(CircuitList)(
  ({ theme }: StyledComponentsParams) => css`
    margin-top: ${theme.spacings.tera};
    & p {
      margin: 0;
    }
  `,
);
export const ItalicText = styled(Body)`
  font-style: italic;
`;

export const UnderlinedText = styled(Body)`
  text-decoration: underline;
`;

export const EmbeddedDownloadButtonContainer = styled('div')(
  ({ theme }: StyledComponentsParams) => css`
    display: block;
    margin-bottom: ${theme.spacings.mega};
  `,
);

export const EmbeddedDownloadButton = styled(Button)`
  display: inline-block;
`;
